var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { format } from 'date-fns';
import { Box, CircularProgress, IconButton, Typography } from '@mui/material';
import { grey } from '@mui/material/colors';
import { useConfirm } from '../../../hooks/confirmationHook';
import AnchorLink from 'react-anchor-link-smooth-scroll';
import reactStringReplace from 'react-string-replace';
import { CancelIcon, DeleteIcon, EditIcon, OkIcon, ReplyIcon, } from '../../atoms/Icons';
import TextField from '../../atoms/TextField';
import TranslateButton from './TranslateButton';
var MessageBody = styled(Typography)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  && {\n    font-size: 1rem;\n    white-space: pre-wrap;\n    margin-bottom: 8px;\n    word-break: break-all;\n\n    blockquote {\n      border-left: 4px solid;\n      margin-left: 16px;\n      padding-left: 16px;\n    }\n  }\n"], ["\n  && {\n    font-size: 1rem;\n    white-space: pre-wrap;\n    margin-bottom: 8px;\n    word-break: break-all;\n\n    blockquote {\n      border-left: 4px solid;\n      margin-left: 16px;\n      padding-left: 16px;\n    }\n  }\n"])));
var Translation = styled(MessageBody)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  && {\n    border-left: 4px solid;\n    margin-left: 16px;\n    padding-left: 16px;\n  }\n"], ["\n  && {\n    border-left: 4px solid;\n    margin-left: 16px;\n    padding-left: 16px;\n  }\n"])));
var MessageTime = styled(Typography)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  && {\n    color: ", ";\n    font-size: 0.85rem;\n    display: inline-block;\n    margin-right: 5px;\n  }\n"], ["\n  && {\n    color: ", ";\n    font-size: 0.85rem;\n    display: inline-block;\n    margin-right: 5px;\n  }\n"])), grey[500]);
var ThreadNumber = styled(Typography)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  && {\n    color: ", ";\n    font-size: 1rem;\n    display: inline-block;\n    margin-right: 5px;\n  }\n"], ["\n  && {\n    color: ", ";\n    font-size: 1rem;\n    display: inline-block;\n    margin-right: 5px;\n  }\n"])), grey[700]);
var MessageAuthor = styled(Typography)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  && {\n    color: ", ";\n    font-size: 0.9rem;\n    font-weight: bold;\n    display: inline-block;\n  }\n"], ["\n  && {\n    color: ", ";\n    font-size: 0.9rem;\n    font-weight: bold;\n    display: inline-block;\n  }\n"])), grey[500]);
var Root = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  padding: 16px 8px;\n"], ["\n  padding: 16px 8px;\n"])));
var Message = function (_a) {
    var className = _a.className, editable = _a.editable, message = _a.message, replyable = _a.replyable, onDelete = _a.onDelete, onReply = _a.onReply, onUpdateBody = _a.onUpdateBody, languagePreference = _a.languagePreference, translateMessage = _a.translateMessage;
    var confirm = useConfirm();
    var t = useTranslation().t;
    var _b = React.useState(false), loading = _b[0], setLoading = _b[1];
    var _c = React.useState(false), editing = _c[0], setEditing = _c[1];
    var _d = React.useState(message.body), editedBody = _d[0], setEditedBody = _d[1];
    var _e = React.useState(), translatedBody = _e[0], setTranslatedBody = _e[1];
    React.useEffect(function () {
        setEditedBody(message.body);
        setLoading(false);
    }, [message]);
    var handleEditChange = React.useCallback(function (event) {
        setEditedBody(event.target.value);
    }, []);
    var handleTranslate = React.useCallback(function (language) {
        setLoading(true);
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            var translation;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, translateMessage(language)];
                    case 1:
                        translation = _a.sent();
                        if (translation) {
                            setTranslatedBody(translation);
                        }
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [translateMessage]);
    return (React.createElement(Root, { className: className, role: "article" },
        React.createElement(ThreadNumber, { id: message.commentNumber },
            "#",
            message.commentNumber),
        editing ? (React.createElement(TextField, { multiline: true, fullWidth: true, rows: 5, value: editedBody, onChange: handleEditChange })) : (React.createElement(React.Fragment, null,
            React.createElement(MessageBody, null, reactStringReplace(message.body, />#(\d+)/g, function (match, index) { return (React.createElement(AnchorLink, { key: index, href: "#".concat(match) }, ">#".concat(match))); })),
            translatedBody && React.createElement(Translation, null, translatedBody),
            React.createElement(TranslateButton, { translated: !!translatedBody, languagePreference: languagePreference, onTranslate: handleTranslate }))),
        React.createElement(Box, { display: "flex", alignItems: "center", lineHeight: "30px" },
            React.createElement(MessageTime, null, format(new Date(message.createdAt), 'yyyy-MM-dd')),
            React.createElement(MessageAuthor, null, t('fullname', message.author)),
            loading ? (React.createElement(Box, { component: "span", ml: 1 },
                React.createElement(CircularProgress, { size: "1.5em" }))) : (editable &&
                (editing ? (React.createElement(React.Fragment, null,
                    React.createElement(IconButton, { onClick: function () {
                            setLoading(true);
                            onUpdateBody(editedBody);
                            setEditing(false);
                        }, size: "small", "aria-label": "Save", disabled: !editedBody.trim() },
                        React.createElement(OkIcon, null)),
                    React.createElement(IconButton, { onClick: function () {
                            setEditedBody(message.body);
                            setEditing(false);
                        }, size: "small", "aria-label": "Cancel" },
                        React.createElement(CancelIcon, null)))) : (React.createElement(React.Fragment, null,
                    React.createElement(IconButton, { onClick: function () { return setEditing(true); }, size: "small", "aria-label": "Edit" },
                        React.createElement(EditIcon, null)),
                    React.createElement(IconButton, { onClick: function () {
                            var title = t('messages.deleteCommentConfirmTitle');
                            var body = t('messages.deleteCommentConfirmBody');
                            confirm(title, body, function () {
                                setLoading(true);
                                onDelete();
                            });
                        }, size: "small", "aria-label": "Delete" },
                        React.createElement(DeleteIcon, null)))))),
            replyable && (React.createElement(IconButton, { onClick: function () {
                    onReply(message.commentNumber);
                }, size: "small", "aria-label": "Reply" },
                React.createElement(ReplyIcon, null))))));
};
export default Message;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
